<template>
    <div class="grid h-100vh">
      <div class="grid-title">
        <h4>{{ $t("MANAGE_SYNC_OTA") }}</h4>
      </div>
      <div class="grid-body p-3 border-top-unset d-main">
          <v-progress-linear
              color="warning"
              :indeterminate="true"
              rounded
              height="3"
              v-if="isLoading"
          ></v-progress-linear>
          <div v-if="!isLoading" class="h-100">
              <v-row >
                <template v-if="listOTAConnected.length > 0">
                  <v-col sm="3" class="pb-0 pt-0">
                    <v-list dense class="pt-0">
                        <v-list-item-group mandatory v-model="selectedItem">
                        <v-list-item
                            v-for="(item, i) in listOTAConnected"
                            :key="i"
                            :value="item.id"
                        >
                            <v-list-item-content>
                            <v-list-item-title
                                v-text="item.otaI18n.find(x => x.lang == defaultI18n).name"
                            >
                            </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon>
                            <v-progress-circular
                              v-if="getConnectStatus"
                              color="blue-lighten-3" 
                              indeterminate 
                              :size="20" 
                              :width="2"
                            ></v-progress-circular>
                            <v-icon
                              v-else
                              :class="item.connectionStatus"
                            >cloud_done</v-icon
                            >
                            </v-list-item-icon>
                        </v-list-item>
                        </v-list-item-group>
                    </v-list>
                  </v-col>
                
                  <v-col sm="9" class="pb-0 pt-0 border-left" >
                    <div v-if="!isError && dataPriceLabs" class="pb-3 d-flex align-items-end">
                     <div class="w-50 d-flex align-items-center mr-auto">
                      <label class="label-input mr-3">PricesLabs email ID</label>
                      <v-text-field class="w-50" v-model="dataPriceLabs.email" :disabled="!dataPriceLabs.isEdit" outlined dense :rules="ruleEmailNotRequied"></v-text-field>
                     </div>
                      <v-btn depressed color="warning" @click="syncOta()" :disabled="isUpdating"> {{ $t('SYNC_FROM_PRICELABS') }} </v-btn>
                    </div>
                    <div v-if="!isError && dataPriceLabs && dataPriceLabs.roomRates.length > 0">
                      <div class="tbl-connect" @scroll="loadData">
                        <v-row class="d-header-table mr-0 ml-0">
                            <v-col sm="4" class="pt-0 pb-0">
                              <v-row>
                                <v-col>
                                  {{$t('ROOM_TYPE')}}
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col class="pt-0 pb-0">
                                <v-row>
                                  <v-col>
                                    {{$t('_SALE_PACKAGE.SALE_PACKAGE')}}
                                  </v-col>
                                  <v-col sm="3">
                                    <span >{{$t('STATUS')}}</span>
                                  </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row 
                          class="mt-0 border-bottom mr-0 ml-0"
                          v-for="(room, index) in tmpDataPriceLabs.roomRates"
                          :key="'dataPriceLabs_'+index"
                        >
                            <v-col sm="4" class="border-right">
                              <strong class="fs-12">
                                {{room.roomTypeI18n.find(e => e.lang === defaultI18n).name}} ({{ $t("HOTEL_LOG_id")}}
                                : {{ room.roomTypeCode + (room.externalRoomCode ? ' | ' +  room.externalRoomCode : '')}})
                              </strong>
                            </v-col>
                            <v-col class="pt-0 pb-0">
                              <v-row 
                              class="border-bottom mt-0 d-plan"
                              v-for="(rate, ind) in room.ratePlans"
                              :key="'dataPriceLabs_'+index+'_ratePlans_'+ind"
                              >
                                <v-col>
                                  <span>
                                    {{rate.ratePlanI18n.find(e => e.lang === defaultI18n).name}} 
                                    ({{$t("HOTEL_LOG_id")}}: {{ rate.ratePlanCode }}
                                    <span v-if="rate.externalPlanCode"> - {{ rate.externalPlanCode }}</span>)
                                  </span>
                                </v-col>
                                <v-col sm="2" class="d-middle">
                                  <v-switch color="primary" v-model="rate.roomRates[0].status" class="p-0 m-0" :disabled="rate.roomRates[0].connectionStatus === 2"></v-switch>
                                </v-col>
                                <v-col sm="3">
                                  <span :class="optionStatus.find(e => e.value === rate.roomRates[0].connectionStatus).text">
                                    {{$t(optionStatus.find(e => e.value === rate.roomRates[0].connectionStatus).text)}}
                                  </span>
                                </v-col>
                              </v-row>
                            </v-col>
                        </v-row>
                        <div v-if="loadingMore" class="text-center py-2" style="position:sticky; left: 0;">
                          <v-progress-circular
                            :width="2"
                            color="gray"
                            indeterminate
                          ></v-progress-circular>
                        </div>
                      </div>
                      <div class="text-right mt-3">
                        <v-btn :disabled="isUpdating" class="mr-3" v-if="listOTAConnected.find(e => e.id === selectedItem).connectionStatus" outlined color="primary" @click="syncData(selectedItem)"> {{$t('SYNC')}} </v-btn>
                        <v-btn :disabled="isUpdating" depressed color="primary" @click="update()"> {{$t('MAP')}} </v-btn>
                      </div>
                    </div>
                    <div  v-else>
                      <v-row style="text-align: center">
                        <v-col sm="12">
                          <v-icon style="height: 100%; font-size: 150px" color="#fed12f"
                            >warning</v-icon
                          >
                        </v-col>
                        <v-col sm="12">
                          <p style="margin: auto">
                            {{ $t("ROOM_AND_PRICE_PACKAGES_HAVE_NOT_BEEN_DECLARED") }}
                          </p>
                        </v-col>
                      </v-row>
                    </div>
  
                  </v-col>
                </template>
                <template v-else-if="isErrorConnect">
                  <v-col class="p-0"  >
                    <v-row style="text-align: center">
                      <v-col sm="12">
                        <v-icon style="height: 100%; font-size: 150px" color="#fed12f"
                          >warning</v-icon
                        >
                      </v-col>
                      <v-col sm="12">
                        <p style="margin: auto">
                          {{ $t("CANNOT_GET_INFO_FROM_OTA_1") }}
                          <br />
                          {{ $t("CANNOT_GET_INFO_FROM_OTA_2") }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-col>
                </template>
                <template v-else>
                  <v-col class="p-0"  >
                    <v-row style="text-align: center">
                      <v-col sm="12">
                        <v-icon style="height: 100%; font-size: 150px" color="#fed12f"
                          >warning</v-icon
                        >
                      </v-col>
                      <v-col sm="12">
                        <p style="margin: auto">
                          {{ $t("NOT_CONNECTED") }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-col>
                </template>
              </v-row>
          </div>
      </div>
    </div>
  </template>
  
<style lang="scss" scoped>
  .description-price {
    padding: 10px;
    p {
      margin-bottom: 2px;
      span {
        font-weight: bold;
      }
    }
  }
  .ifram-ota{
      height: calc(100% - 85px) !important;
  }
  .d-main{
      height: calc(100vh - 130px);
  }
  .d-plan:last-child{
    border-bottom: none !important;
  }
</style>
  
<script>
  import { REGEX_NUMBER } from "@/_helpers/constant.js";
  import { _alert, _alertLink } from "@/_helpers/function.js";
  import { velaOta } from "@/_services/SyncOTA/VelaOta.service.js";
  import moment from "moment";
  import { syncota } from "@/_services/SyncOTA/syncota.js";
  
  export default {
    data() {
      return {
        sysLang: this.$i18n.locale,
        isLoading: false,
        selectedItem: null,
        listOTAConnected: [],
        actionTab: 'SALE_CHANNEL',
        iframeUrl: null,
        conectedDetail: [],
        isError: false,
        selectIdDetail: null,
        optionStatus: [
          {
            value: 0,
            text: 'NOT_CONNECTED'
          },
          {
            value: 1,
            text: 'CONNECTED'
          },
          {
            value: 2,
            text: 'MISSING_ROOM_AND_PRICE'
          },
          {
            value: 3,
            text: 'CONNECTING'
          },
          {
            value: 4,
            text: 'CONNECTION_FAILED'
          }
        ],
        isIframe: false,
        isErrorConnect: false,
        isVisibleChannel: false,
        isVisibleMap: false,
        dataPriceLabs: {
          roomRates: [],
          email: null,
          isEdit: true
        },
        tmpDataPriceLabs: {
          roomRates: [],
          email: null,
          isEdit: true
        },
        perPage: 0,
        totalPage: 0,
        itemPerPage: 2,
        loadingMore: false,
        maxHeight: 100,
        getConnectStatus: true,
        isUpdating: false,
      };
    },
    computed: {
      REGEX_NUMBER() {
        return REGEX_NUMBER;
      },
    },
    created() {
      this.initialize();
    },
    watch: {
      selectedItem(value) {
        // Lấy thông tin chi tiết đồng bộ của 1 kênh
        this.isLoading = true;
        this.isError = false;
        this.dataPriceLabs.roomRates = [];
        this.selectIdDetail = value;
        this.detailOta(value);
      },
      actionTab(value) {
        if (value === 'OTA_CONNECT' && this.isVisibleMap === false) {
          this.getIframeSu();
        }
      }
    },
    methods: {
      loadData(event) {
        if (this.loadingMore) {
          return;
        }
        const table = event.target;
        const scrollTop = table.scrollTop;
        const clientHeight = table.clientHeight;
        const scrollHeight = table.scrollHeight;

        if (scrollHeight - scrollTop - clientHeight <= 100 && this.perPage < this.totalPage) {
          this.loadingMore = true;
          setTimeout(() => {
            this.tmpDataPriceLabs.roomRates = [
              ...this.tmpDataPriceLabs.roomRates, 
              ...this.dataPriceLabs.roomRates.slice(this.perPage * this.itemPerPage, (this.perPage + 1) * this.itemPerPage)
            ];
            this.perPage += 1;
            this.loadingMore = false;
          }, 1000);
        }
      },
      onResize() {
        this.maxHeight = (window.innerHeight - 290 - 50);
      },
      async syncData(id) {
        this.isUpdating = true;
        await syncota.pricesLabSyncData(id).then(res => {
          _alert(res, this.$t(res.data), false);
        }).finally(() => (this.isUpdating = false));
      },
      async initialize() {
        this.isLoading = true;
        let body = {
          keyword: "",
          status: 1
        };
        await velaOta.getAllPriceLabOTA(body).then(res => {
          if (res.responseCode === 0) {
            this.isErrorConnect = false;
              this.listOTAConnected = res.data;
              this.listOTAConnected.forEach(it => {
                it.connectionStatus = it.connectionStatus + "-RoomTypeOTA";
              });
              this.selectedItem = this.listOTAConnected.length > 0 ? this.listOTAConnected[0].id : null;
          } else {
            this.isErrorConnect = true;
            _alert(res, this.$t(res.data), false);
          }
          this.isLoading = false;
          this.getListConnectStatus();
        });
      },
      async getListConnectStatus() {
        let body = {
          keyword: "",
          status: 1
        };
        await velaOta.getStatusPriceLabOTA(body).then(res => {
          if (res.responseCode === 0) {
            const data = res.data;
            data.forEach(it => {
              const OTA = this.listOTAConnected.find(e => e.id === it.id);
              OTA.connectionStatus = it.connectionStatus + "-RoomTypeOTA";
            });
            this.getConnectStatus = false;
          }
        });
      },
      detailOta(value) {
        const minRow = Math.ceil(this.maxHeight / 40) + 5;
        this.perPage = 0;
        this.totalPage = 0;
        this.itemPerPage = 1;
        velaOta
          .detailPricelabSyncOTA(value)
          .then(res => {
            if (res.responseCode === 0) {
              const data = res.data;
              let ratePlanLength = 0;
              if (data.roomRates.length > 0) {
                data.roomRates.forEach((room) => {
                  ratePlanLength += room.ratePlans.length;
                  if (ratePlanLength < minRow) {
                    this.itemPerPage += 1;
                  }
                })
              }
              this.dataPriceLabs = data;
              this.totalPage = Math.ceil(this.dataPriceLabs.roomRates.length / this.itemPerPage);
              this.tmpDataPriceLabs.email = this.dataPriceLabs.email;
              this.tmpDataPriceLabs.isEdit = this.dataPriceLabs.isEdit;
              this.tmpDataPriceLabs.roomRates = this.dataPriceLabs.roomRates.slice(this.perPage * this.itemPerPage, (this.perPage + 1) * this.itemPerPage);
              this.perPage += 1;
            } else {
              if (res.data == "OTA_CONNECTION_ERROR") {
                this.isError = true;
              } else {
                _alert(res, this.$t(res.data), false);
              }
            }
          })
          .finally(() => (this.isLoading = false));
      },
      update() {
        this.isUpdating = true;
        velaOta
          .updateDetailPricelabOTA(this.dataPriceLabs, this.selectedItem)
          .then(res => {
           this.detailOta(this.selectIdDetail);
           if (res.responseCode === 2) {
              _alertLink(res, this.$t('ACCESS_TOKEN_EMAIL_IS_NOT_EMPTY'), 'hotelSettingConfig');
            } else {
              _alert(res, this.$t(res.data), false);
            }
            
          })
          .finally(() => (this.isUpdating = false));
      },
      syncOta() {
        this.isUpdating = true;
        velaOta
          .syncPricelabs(this.selectedItem)
          .then(res => {
            _alert(res, this.$t(res.data), false);
          })
          .finally(() => (this.isUpdating = false));
      },
      _moment: moment
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.onResize);
    },
    mounted() {
      this.onResize();
      window.addEventListener("resize", this.onResize);
    }
  };
</script>